import React, { useState } from 'react';

import { SaveOutlined } from '@ant-design/icons';
import ListPageHeader from '@components/shared/ListPageHeader';
import WarehouseForm from '@components/shared/warehouses/WarehouseForm';
import { Button, Card, Form, Space, message } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { warehouseService } from '@services/operator/warehouseService';
import { handleApiError } from '@utils/apiErrorHandler';

const NEW_WAREHOUSE_DEFAULTS = {
  name: '',
  phone: '',
  postal_code: '',
  address: '',
  allow_mixed_inventory_types: true,
  timezone: 'Asia/Taipei',
  storage_mode: 'dynamic',
};

const WarehouseNew = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [locationTemplate, setLocationTemplate] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleFinish = async (values) => {
    setSubmitting(true);
    try {
      const data = await warehouseService.create(values);
      if (data.success) {
        message.success(t('common.message.create_success'));
        navigate(`/warehouses/${data.data.id}`, { replace: true });
      } else {
        handleApiError(data, { t, fallbackMessage: t('common.error.create_failed') });
      }
    } catch (error) {
      console.error('Create warehouse error:', error);
      message.error(t('common.error.create_failed'));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={{ padding: '24px' }}>
      <ListPageHeader
        items={[
          'warehouse_settings',
          'warehouse_settings.warehouses',
          { label: t('common.button.new') },
        ]}
      />
      <Card bordered={false} className="shadow-sm">
        <WarehouseForm
          form={form}
          initialValues={NEW_WAREHOUSE_DEFAULTS}
          locationTemplate={locationTemplate}
          onLocationTemplateChange={setLocationTemplate}
          onFinish={handleFinish}
        />
        <Form.Item style={{ marginTop: 24, marginBottom: 0 }}>
          <Space style={{ width: '100%', justifyContent: 'flex-end' }}>
            <Button onClick={() => navigate('/warehouses')}>
              {t('common.button.cancel')}
            </Button>
            <Button
              type="primary"
              icon={<SaveOutlined />}
              loading={submitting}
              onClick={() => form.submit()}
            >
              {t('common.button.create')}
            </Button>
          </Space>
        </Form.Item>
      </Card>
    </div>
  );
};

export default WarehouseNew;
